import React, { useState } from "react";
import "./WaterModal.css";
import { MdClose } from "react-icons/md";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import { useBaseUrl } from "../../ApiContext";

export default function WaterModal({ setShowWaterModal, onSaveAlert, date }) {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [activeWaterUnit, setActiveWaterUnit] = useState(["cup", "فنجان"]);
  const [waterQuantity, setWaterQuantity] = useState(0);

  const closeWaterModalHandler = () => {
    setShowWaterModal(false);
  };
  const modalContentClickHandler = (event) => {
    event.stopPropagation();
  };
  const changeActivityHandler = (unit) => {
    setActiveWaterUnit(unit);
  };
  const addQuantityHandler = () => {
    setWaterQuantity((prevQuantity) => prevQuantity + 1);
  };
  const minusQuantityHandler = () => {
    setWaterQuantity((prevQuantity) => {
      if (prevQuantity > 0) {
        return prevQuantity - 1;
      } else {
        return 0;
      }
    });
  };
  const saveWaterDataHandler = async () => {
    let milliliterResult = 0;
    let liter = 0;
    let milliliterResult2 = 0;
    let waterAmountRequest = null;
    if (activeWaterUnit[1] === "فنجان") {
      milliliterResult = waterQuantity * 100;
    } else if (activeWaterUnit[1] === "لیوان") {
      milliliterResult = waterQuantity * 150;
    } else if (activeWaterUnit[1] === "1 لیتری") {
      milliliterResult = waterQuantity * 1000;
    } else if (activeWaterUnit[1] === "2 لیتری") {
      milliliterResult = waterQuantity * 2000;
    }
    liter = Math.floor(milliliterResult / 1000);
    milliliterResult2 = milliliterResult - liter * 1000;
    waterAmountRequest = { liter, milliliterResult2 };

    try {
      const response = await Axios.post(
        `${baseUrl}/report/diet_plan/water/${date}`,
        {
          litre: waterAmountRequest.liter,
          millilitre: waterAmountRequest.milliliterResult2,
        },
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      console.log(response.data);
    } catch (error) {
      console.log("Error during posting water data", error);
    }
    onSaveAlert();
  };
  
  return (
    <div
      className="waterModalBackDrop centeredFlex"
      onClick={closeWaterModalHandler}
    >
      <div
        className="waterModal"
        onClick={(event) => modalContentClickHandler(event)}
      >
        <div
          className="waterModalCloseWrapper centeredFlex"
          onClick={closeWaterModalHandler}
        >
          <MdClose className="waterModalClose" />
        </div>
        <div className="waterModalHeader centeredFlex">
          <div className="waterModalHeaderDrop">
            <img
              src="/images/waterDrop.svg"
              alt="water drop icon"
              className="modalWaterDropIcon"
            />
            <span>0%</span>
          </div>
        </div>
        <div className="waterModalMeasures centeredFlex">
          <div className="waterModalMeasureItem">
            <svg
              onClick={() => changeActivityHandler(["bigBottle", "2 لیتری"])}
              className="waterModalBigBottle"
              viewBox="0 0 24 62"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.0230257 25.6887C0.0230257 26.9108 0.546269 27.8852 1.31872 28.4767C1.53397 28.7185 1.77455 28.9475 2.04066 29.1606C2.1188 29.2232 2.17918 29.2657 2.23162 29.3056C2.05378 29.4652 1.8395 29.6199 1.65295 29.8091C-0.737278 32.2351 -0.472238 35.6507 2.04066 37.6633C2.25273 37.8332 2.33299 37.8545 2.48276 38.0798C2.05509 38.1803 1.92283 38.2275 1.57999 38.4632C0.80718 38.9944 0.0230257 39.9489 0.0230257 40.9891V58.8753C0.0230257 60.3713 1.63965 62 3.12445 62H20.8776C21.6768 62 22.5704 61.4347 22.9942 61.0077C23.4179 60.5808 23.979 59.6804 23.979 58.8753V40.9891C23.979 39.8263 22.882 38.3997 21.5193 38.0798C21.7532 37.728 22.5498 37.2796 23.1468 36.3794C24.6379 34.1314 24.1321 31.1841 21.9614 29.4456C21.8847 29.3841 21.8253 29.3421 21.7736 29.3029C22.0284 29.071 22.3997 28.7834 22.7582 28.3795C23.4396 27.8195 23.979 26.9863 23.979 26.1198C23.979 25.9834 23.9725 25.8435 23.9603 25.7009C24.1624 24.0997 23.5842 22.4481 22.3134 21.2492C22.1518 20.9893 21.9876 20.7481 21.8252 20.5319C21.8063 20.5069 21.7863 20.4805 21.7654 20.4534C22.8284 20.0769 23.979 18.8828 23.979 17.617C23.979 15.8217 22.8657 13.4138 21.8252 12.0292C21.1255 11.0982 19.0365 8.67391 17.9901 8.67391H6.01205C4.95465 8.67391 2.85949 11.121 2.17688 12.0292C1.61941 12.7711 1.26697 13.4882 0.875376 14.3813C0.631268 14.9382 0.0230257 16.4564 0.0230257 17.186C0.0230257 18.8468 0.989248 20.0503 2.23417 20.4565C2.21419 20.4826 2.19501 20.508 2.17688 20.5319C1.98636 20.7855 1.81988 21.0361 1.66747 21.2919L1.65295 21.3064C0.397291 22.5809 -0.125333 24.1285 0.0256726 25.6023C0.0240006 25.6322 0.0230257 25.6611 0.0230257 25.6887ZM6.16649 1.26338V4.51219C6.16649 5.07579 6.86115 5.77557 7.42056 5.77557H16.3778C16.9371 5.77557 17.6318 5.07579 17.6318 4.51219V1.26338C17.6318 0.69987 16.9371 0 16.3778 0H7.42056C6.86115 0 6.16649 0.69987 6.16649 1.26338Z"
                fill={
                  activeWaterUnit[0] === "bigBottle" ? "#4EA8E9" : "#AFAFAF"
                }
              />
            </svg>
          </div>
          <div className="waterModalMeasureItem">
            <svg
              onClick={() => changeActivityHandler(["smallBottle", "1 لیتری"])}
              className="waterModalSmallBottle"
              viewBox="0 0 21 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="_2078645050256">
                <path
                  id="Vector"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.0194444 16.6851C0.0194444 18.1687 0.94621 19.2172 2.09685 19.4852C1.94219 19.7161 1.64083 19.8926 1.39601 20.1392C-0.622653 22.1728 -0.398856 25.0359 1.72345 26.7231C1.90252 26.8655 1.97032 26.8834 2.09685 27.0723C1.73561 27.1565 1.62398 27.1962 1.33435 27.3937C0.68169 27.839 0.0194444 28.6391 0.0194444 29.511V44.5046C0.0194444 45.7586 1.38475 47.1239 2.63877 47.1239H17.6324C18.3073 47.1239 19.0621 46.6501 19.42 46.2921C19.7778 45.9342 20.2517 45.1796 20.2517 44.5046V29.511C20.2517 28.5363 19.3251 27.3404 18.1743 27.0723C18.3718 26.7774 19.0445 26.4014 19.5488 25.6468C20.8082 23.7625 20.3811 21.2917 18.5477 19.8343C18.3686 19.692 18.3008 19.6741 18.1743 19.4852C19.1226 19.2643 20.2517 18.1901 20.2517 17.0465C20.2517 15.5416 19.3114 13.5229 18.4326 12.3624C17.8417 11.5819 16.0774 9.54968 15.1936 9.54968H5.07751C4.18447 9.54968 2.41497 11.6011 1.83854 12.3624C1.3677 12.9842 1.06999 13.5854 0.739362 14.3341C0.533138 14.8008 0.0194444 16.0736 0.0194444 16.6851Z"
                  fill={
                    activeWaterUnit[0] === "smallBottle" ? "#4EA8E9" : "#AFAFAF"
                  }
                />
                <path
                  id="Vector_2"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.35498 2.14328V5.39493C4.35498 5.95894 5.05547 6.65943 5.61947 6.65943H14.6518C15.2158 6.65943 15.9163 5.95894 15.9163 5.39493V2.14328C15.9163 1.57927 15.2158 0.878784 14.6518 0.878784H5.61947C5.05547 0.878784 4.35498 1.57927 4.35498 2.14328Z"
                  fill={
                    activeWaterUnit[0] === "smallBottle" ? "#4EA8E9" : "#AFAFAF"
                  }
                />
              </g>
            </svg>
          </div>
          <div className="waterModalMeasureItem">
            <svg
              onClick={() => changeActivityHandler(["glass", "لیوان"])}
              className="waterModalGlass"
              viewBox="0 0 22 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.630236 0.0586462H0.515642V0.117203H0.401049V0.175849H0.343789V0.234405H0.286447V0.292962H0.229196V0.351604H0.171936V0.410165H0.114594V0.527363H0.0573428V0.644566H0V1.46489H0.0573428V2.05081H0.114594V2.63673H0.171936V3.22274H0.229196V3.80865H0.286447V4.39458H0.343789V4.9805H0.401049V5.56642H0.458383V6.15242H0.515642V6.73835H0.572902V7.32427H0.630236V7.91019H0.687495V8.49611H0.744838V9.08203H0.802089V9.66803H0.859432V10.254H0.916691V10.8399H0.974025V11.4258H1.03128V12.0117H1.08854V12.5977H1.14588V13.1836H1.20314V13.7696H1.26048V14.3555H1.31773V14.9415H1.37499V15.5274H1.43233V16.1133H1.48958V16.6993H1.54693V17.2852H1.60419V17.8712H1.66144V18.4571H1.71878V19.043H1.77603V19.6289H1.83337V20.2149H1.89063V20.8008H1.94798V21.3868H2.00523V21.9727H2.06249V22.5586H2.11983V23.1445H2.17708V23.7305H2.23442V24.3165H2.29167V24.9024H2.34902V25.4883H2.40628V26.0742H2.46353V26.6602H2.52087V27.2462H2.57813V27.8321H2.63547V28.418H2.69272V29.0039H2.74998V29.3555H2.80732V29.4727H2.86457V29.5899H2.92192V29.6485H2.97917V29.707H3.03643V29.7657H3.09377V29.8242H3.15102V29.8829H3.26562V29.9415H3.38022V30H18.6198V29.9415H18.7344V29.8829H18.849V29.8242H18.9062V29.7657H18.9635V29.707H19.0208V29.6485H19.0781V29.5899H19.1354V29.4727H19.1927V29.3555H19.2499V29.0039H19.3073V28.418H19.3645V27.8321H19.4219V27.2462H19.4791V26.6602H19.5364V26.0742H19.5937V25.4883H19.651V24.9024H19.7083V24.3165H19.7656V23.7305H19.8229V23.1445H19.8802V22.5586H19.9375V21.9727H19.9948V21.3868H20.052V20.8008H20.1094V20.2149H20.1666V19.6289H20.224V19.043H20.2812V18.4571H20.3385V17.8712H20.3958V17.2852H20.4531V16.6993H20.5104V16.1133H20.5677V15.5274H20.6249V14.9415H20.6823V14.3555H20.7395V13.7696H20.7969V13.1836H20.8541V12.5977H20.9114V12.0117H20.9687V11.4258H21.026V10.8399H21.0833V10.254H21.1406V9.66803H21.1979V9.08203H21.2552V8.49611H21.3125V7.91019H21.3698V7.32427H21.427V6.73835H21.4844V6.15242H21.5416V5.56642H21.599V4.9805H21.6562V4.39458H21.7135V3.80865H21.7708V3.22274H21.8281V2.63673H21.8854V2.05081H21.9427V1.46489H22V0.644566H21.9427V0.527363H21.8854V0.410165H21.8281V0.351604H21.7708V0.292962H21.7135V0.234405H21.6562V0.175849H21.599V0.117203H21.4844V0.0586462H21.3698V0H0.630236V0.0586462ZM1.94798 1.87505H20.052V2.16801H19.9948V2.75393H19.9375V3.33985H19.8802V3.92577H19.8229V4.51178H19.7656V5.0977H19.7083V5.68362H19.651V6.26954H19.5937V6.85546H19.5364V7.44146H19.4791V8.02739H19.4219V8.61331H19.3645V9.19923H19.3073V9.49219H19.2499V9.55083H19.0781V9.60939H18.849V9.66803H18.677V9.72659H18.4478V9.78523H18.2187V9.84379H17.9323V9.90235H17.6458V9.96099H17.3594V10.0195H16.8437V10.0782H16.1562V10.1368H15.526V10.0782H14.8385V10.0195H14.4947V9.96099H14.2083V9.90235H13.9792V9.84379H13.75V9.78523H13.5781V9.72659H13.4063V9.66803H13.2917V9.60939H13.1197V9.55083H13.0052V9.49219H12.8906V9.43363H12.776V9.37499H12.6614V9.31643H12.5468V9.25787H12.4323V9.19923H12.3177V9.14067H12.2604V9.08203H12.1458V9.02347H12.0312V8.96491H11.9739V8.90627H11.9167V8.84771H11.8021V8.78906H11.7447V8.73051H11.6875V8.67195H11.5729V8.61331H11.5156V8.55475H11.4583V8.49611H11.3437V8.43755H11.2864V8.3789H11.2292V8.32035H11.1146V8.26179H11.0573V8.20314H11V8.14459H10.8854V8.08595H10.7708V8.02739H10.7136V7.96874H10.599V7.91019H10.5416V7.85163H10.4271V7.79298H10.3125V7.73443H10.1979V7.67578H10.0833V7.61722H9.96871V7.55867H9.85421V7.50003H9.7396V7.44146H9.56767V7.38282H9.45307V7.32427H9.33856V7.26571H9.16663V7.20706H8.99477V7.14851H8.82292V7.08986H8.59373V7.0313H8.36462V6.97266H8.13543V6.9141H7.84898V6.85546H7.50519V6.7969H6.98955V6.73835H5.38544V6.7969H4.75521V6.85546H4.35416V6.9141H4.01045V6.97266H3.72401V7.0313H3.43756V7.08986H3.20836V7.14851H2.97917V7.20706H2.74998V7.26571H2.52087V7.32427H2.46353V6.85546H2.40628V6.26954H2.34902V5.68362H2.29167V5.0977H2.23442V4.51178H2.17708V3.92577H2.11983V3.33985H2.06249V2.75393H2.00523V2.16801H1.94798V1.87505Z"
                fill={activeWaterUnit[0] === "glass" ? "#4EA8E9" : "#AFAFAF"}
              />
            </svg>
          </div>
          <div className="waterModalMeasureItem">
            <svg
              onClick={() => changeActivityHandler(["cup", "فنجان"])}
              className="waterModalCup"
              viewBox="0 0 29 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Frame 48095797">
                <path
                  id="Vector"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.70922 2.20565C2.70922 3.55492 3.67205 4.52071 3.67205 5.16806C3.67205 6.29316 3.21898 5.72082 3.21898 6.59436C3.21898 7.13182 3.68288 7.52702 4.2385 7.52702C5.03948 7.52702 5.6545 6.29403 5.6545 5.27779C5.6545 3.78321 4.69167 3.16103 4.69167 2.15074C4.69167 1.69084 5.61902 0.984726 4.90687 0.29645C4.63832 0.0368603 4.4446 0.0112413 4.06862 0.0112413C3.61952 0.0112413 3.2735 0.519931 3.09341 0.822275C2.90195 1.14368 2.70922 1.71707 2.70922 2.20565ZM23.7324 19.4615H21.1836C21.1918 19.1014 21.2969 18.7486 21.2969 18.1997V13.8658H24.2422C25.8388 13.8658 27.1584 15.3107 27.0297 16.8364C26.9638 17.6183 26.6402 18.3207 26.0317 18.7809C25.3922 19.2647 24.8393 19.4615 23.7324 19.4615ZM0 11.0131V19.0226C0 19.8261 0.318385 20.8411 0.587394 21.5807C0.697795 21.8844 0.797725 22.0264 0.913723 22.3069C1.38313 23.4416 2.87252 24.9092 3.96408 25.6066C6.59675 27.2886 9.38035 26.9773 12.5176 26.9773C13.5595 26.9773 14.7418 26.7595 15.5033 26.4678C16.4909 26.0894 17.451 25.5956 18.2521 24.9061C19.1912 24.0977 20.4532 22.4792 20.7304 21.3267C21.7315 21.3267 24.512 21.4102 25.3651 21.2075C27.3531 20.7351 29 18.8431 29 16.8831C29 15.9316 28.9191 15.4079 28.529 14.5963C27.7771 13.0323 26.0306 11.9457 23.9023 11.9457H21.2969C21.2969 11.2545 21.4282 10.0804 20.2773 10.0804H0.962923C0.445217 10.0804 0 10.5116 0 11.0131ZM9.50611 2.04101C9.50611 4.25972 11.0732 4.87595 10.2345 5.92847C9.28864 7.11555 11.1446 8.35999 12.0367 6.74134C12.2777 6.304 12.4761 5.73297 12.4366 5.23775C12.293 3.44265 11.4885 3.36405 11.4885 2.09592C11.4885 1.53923 11.9416 1.5547 11.9416 0.943807C11.9416 0.432759 11.511 0.0112413 10.9221 0.0112413C10.3815 0.0112413 10.1344 0.403296 9.91268 0.734232C9.70876 1.03876 9.50611 1.55051 9.50611 2.04101ZM16.2463 2.20565C16.2463 3.76511 17.2092 4.15183 17.2092 5.49716C17.2092 5.97097 16.7561 5.88668 16.7561 6.59436C16.7561 7.3629 17.9472 8.17052 18.7938 6.7576C19.9778 4.78143 18.2287 3.24978 18.2287 2.15074C18.2287 1.43291 18.6818 1.86116 18.6818 0.779259C18.6818 0.582272 18.5013 0.348036 18.3843 0.244515C17.8258 -0.249833 17.0485 0.0379124 16.6234 0.815283C16.3885 1.24484 16.2463 1.70431 16.2463 2.20565Z"
                  fill={activeWaterUnit[0] === "cup" ? "#4EA8E9" : "#AFAFAF"}
                />
              </g>
            </svg>
          </div>
        </div>
        <div className="waterModalFooter">
          <div className="waterModalQuantity centeredFlex">
            <div
              className="waterQuantityBtn centeredFlex waterAddQuantity"
              onClick={addQuantityHandler}
            >
              <AddIcon className="waterQuantityIcon" />
            </div>
            <div className="waterQuantity centeredFlex">{waterQuantity}</div>
            <div
              className="waterQuantityBtn centeredFlex waterMinusQuantity"
              onClick={minusQuantityHandler}
            >
              <RemoveIcon className="waterQuantityIcon" />
            </div>
            <p className="waterUnit">{activeWaterUnit[1]}</p>
          </div>
          <button onClick={saveWaterDataHandler}>ذخیره</button>
        </div>
      </div>
    </div>
  );
}
